import React, { useEffect } from "react";
import { createPortal } from "react-dom";

const LogoutConfirmationModal = ({ isOpen, onClose, onConfirm }) => {
  // Handle escape key press
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const modalContent = (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 animate-fade-in px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-sm rounded-xl bg-navy-800 p-6 shadow-lg animate-fade-in"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="mb-4 text-xl font-bold text-white">Logout</h2>
        
        <p className="mb-6 text-lg text-white">
        Are you sure you want to logout?
        </p>

        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="modal-btn rounded-md bg-gray-600 px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="modal-btn rounded-md bg-primary-gradient px-6 py-2 text-sm font-medium text-white transition-colors hover:opacity-90"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default LogoutConfirmationModal;

